export default {
  404: {
    title: '404 Seite nicht gefunden',
    text: 'Die gesuchte Seite ist nicht verfügbar.<br />Versuche zur Startseite zurückzukehren oder probiere es später erneut.',
  },
  500: {
    title: '500 Interner Serverfehler',
    text: 'Entschuldigung, es ist ein interner Fehler aufgetreten.<br />Wir arbeiten daran, das Problem so schnell wie möglich zu beheben.<br />Versuche zur Startseite zurückzukehren oder probiere es später erneut.',
  },
}
